"use client";

import { useState } from "react";
import CopyCodeButton from "@/components/CopyCodeButton";
import FeaturedOffer from "@/components/FeaturedOffer";
import type { GamePromoCode } from "@/lib/data/types";

const PAGE_SIZE = 12;

export default function PromoCodeList({
  codes,
  offerPlacement,
  offerSlug,
}: {
  codes: GamePromoCode[];
  // Set to mix the sponsored offers into this list (see FeaturedOffer).
  offerPlacement?: string;
  offerSlug?: string;
}) {
  const [visible, setVisible] = useState(PAGE_SIZE);
  const shown = codes.slice(0, visible);
  const hasMore = visible < codes.length;

  return (
    <div>
      {(() => {
        const lis = shown.map((c) => (
          <li key={c.code}>
            <CopyCodeButton code={c.code} reward={c.reward} added={c.added} />
          </li>
        ));
        return offerPlacement ? (
          <FeaturedOffer items={lis} placement={offerPlacement} currentSlug={offerSlug} />
        ) : (
          <ul className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{lis}</ul>
        );
      })()}
      {hasMore && (
        <div className="mt-5 flex items-center gap-4">
          <div className="h-px flex-1 bg-[#dde1e7]" />
          <button
            type="button"
            onClick={() => setVisible((v) => v + PAGE_SIZE)}
            className="flex items-center gap-2 rounded-xl border-[1.5px] border-[#dde1e7] bg-white px-5 py-3 text-sm font-bold text-[#0f172a] transition hover:border-[#1877F2] hover:text-[#1877F2]"
            style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}
          >
            Load {Math.min(PAGE_SIZE, codes.length - visible)} more
            <span className="rounded-full bg-[#f1f5f9] px-2 py-0.5 text-xs font-bold text-[#64748b]">
              {codes.length - visible} left
            </span>
          </button>
          <div className="h-px flex-1 bg-[#dde1e7]" />
        </div>
      )}
    </div>
  );
}
